import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui'

export const useRecipientRowStyles = makeStyles(theme => ({
  recipientRow: {
    display: 'flex',
    flexDirection: 'column',
    margin: `0 0 ${theme.spacing(2)}`,
    padding: `0 0 ${theme.spacing(1)}`,
    borderBottom: `1px solid ${brandColors.coolGray3}`,

    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      padding: `0px`,
      borderBottom: `0px`,
    },
  },
  recipientName: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: `0 0 ${theme.spacing(1)}`,

    [theme.breakpoints.up('md')]: {
      margin: `0`,
    },
  },
  separator: {
    margin: `0 ${theme.spacing(1)}`,
  },
  skeletonWrapper: {
    margin: `0 0 0 ${theme.spacing(1)}`,
  },
  settings: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
      flex: '0 0 285px',
    },
  },
  iconWrapper: {
    margin: `0 ${theme.spacing(1.5)} 0 0`,
  },
  labelWrapper: {
    margin: `0 ${theme.spacing(3)} 0 0`,
  },
}))
